export default {
    RULES_FETCHED: 'RULES_FETCHED',
    RULES_DETAIL_FETCHED: 'RULES_DETAIL_FETCHED',
    RULES_LOADING: 'RULES_LOADING',
};